module.exports = __webpack_public_path__ + "static/img/throttleProBg.6288ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/throttleProBg.png
// module id = /1Io
// module chunks = 1